import Vue from 'vue'
import {
	Button,
	Cell,
	Field,
	Toast,
	Tab, 
	Tabs,
	Search,
	Picker
} from 'vant';

Vue.use(Button)
Vue.use(Cell)
Vue.use(Field)
Vue.use(Toast)
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Search);
Vue.use(Picker);
Vue.prototype.$Toast = Toast;
